import React from 'react'
import AttendanceComp from '../components/AttendanceComp'

export default function Attendance() {
  return (
   <>
        <AttendanceComp/>
   </>
  )
}
